var _path, _circle, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserRemoved = function SvgUserRemoved(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C6.13401 14 3 15.567 3 17.5C3 19.433 6.13401 21 10 21C11.27501 21 12.4704 20.8296 13.5 20.53185",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.1494C21 14.69024 20.88825 14.25771 20.69535 13.87353L16.8735 17.69535C17.25765 17.88825 17.69025 18 18.1494 18C19.7235 18 21 16.7235 21 15.1494ZM15.2988 15.1494C15.2988 15.60795 15.40965 16.0401 15.6021 16.4238L19.4238 12.60206C19.0401 12.40969 18.60795 12.29883 18.1494 12.29883C16.57545 12.29883 15.2988 13.5754 15.2988 15.1494ZM22.7988 15.1494C22.7988 17.71755 20.71755 19.7988 18.1494 19.7988C15.58125 19.7988 13.5 17.71755 13.5 15.1494C13.5 12.5813 15.58125 10.5 18.1494 10.5C20.71755 10.5 22.7988 12.5813 22.7988 15.1494Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6494 13.64942L16.6494 16.6494",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserRemoved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "user-removed.5253dd7d0289a567fd4ecf1188af263d.svg";